"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAttensiClient = function (key) {
    /**
     * Object with all AttensiClients
     */
    var clientsObject = {
        admin_view: null,
        build_server: null,
        creator: null,
        dialogue_review: null,
        engage: null,
        login_service: null,
        portal: null,
        process_documentation: null,
        process: null,
        skills: null,
    };
    /**
     * Check if key is in clientsObject
     */
    return Object.keys(clientsObject).includes(key);
};
//# sourceMappingURL=utils.js.map